import { Button, Grid, Stack } from "@mui/material";
import type { FC } from "react";
import type { UUID } from "../../../../../../utils/uuid";
import { FixedFooter } from "../../../../../generic/components/fixed-footer";
import { FooterBlobs } from "../../../roundabout/footer-blobs";
import { usePreviewContext } from "./preview-context";

type PreviewFooterProps = {
  sidebarOpen: boolean;
  toggleSidebar: () => void;
  onClose?: () => void;
  momentId: UUID;
  isReview: boolean;
  closePreviewDialog?: () => void;
  buttons?: {
    sendTest?: React.ReactNode;
    sendForReview?: React.ReactNode;
    publish?: React.ReactNode;
  };
};

export const PreviewFooter: FC<PreviewFooterProps> = ({
  onClose,
  sidebarOpen,
  toggleSidebar,
  isReview,
  buttons,
}) => {
  const {
    moment_preview_data: { status },
  } = usePreviewContext();
  const continueLabel = status === "finished" ? "Close" : "Continue Editing";

  return (
    <FixedFooter
      sx={{
        width: { lg: "100%" },
        boxShadow: "none",
        borderWidth: 1,
        borderColor: "grey.200",
        borderStyle: "solid",
        background: "background.paper",
      }}
    >
      <Stack
        direction="row-reverse"
        justifyContent={onClose ? "space-between" : "flex-start"}
        alignItems="center"
      >
        <Grid container sx={{ py: 2 }} direction="row" spacing={1}>
          {onClose && (
            <Button
              data-analytics-id="preview-dialog-continue"
              variant="outlined"
              onClick={onClose}
            >
              {continueLabel}
            </Button>
          )}
          {buttons?.sendTest}
          {buttons?.sendForReview}
          {isReview && buttons?.publish}
        </Grid>
        {onClose && (
          <>
            <FooterBlobs />
            <Button
              variant="text"
              onClick={toggleSidebar}
              data-analytics-id="preview-dialog-toggle-sidebar"
            >
              {sidebarOpen ? "Hide side panel" : "Show side panel"}
            </Button>
          </>
        )}
      </Stack>
    </FixedFooter>
  );
};
